<template>
  <div ref="messagesBox" class="overflow-y-scroll h-full">
    <div class="flex flex-col">
      <!--    System messages   -->
      <template v-if="!historyMode">
        <se-chat-box-info
          v-if="(currentUser && isUser) || isAdvisor"
          class="mb-16"
          type="success"
          icon="lock"
          info-text="Your session is private and secure."
        />
        <se-chat-box-divider-info
          v-if="chatInfo && chatInfo.is_free && isAdvisor"
          :text="`Free chat started: ${chatInfo.free_minutes} min left`"
        />
        <template v-if="isUser">
          <se-session-message-bubble
            is-system-message
            message="Congratulations, the <b>Advisor accepted your invitation</b> to chat. You can write a message or wait for the Advisor to type first."
          />
          <se-session-message-bubble
            v-if="props.chatInfo.free_minutes > 0"
            class="mt-1"
            is-system-message
            :message="`<b>First ${props.chatInfo.free_minutes} minutes are free</b> and you can choose to use your paid minutes after this.`"
          />
        </template>
        <se-session-message-bubble
          v-else-if="isAdvisor"
          is-system-message
          message="Your chat with the client has started. If they are shy, be the one to write something and break the ice."
        />
      </template>
      
      <!--    Conversation messages + System notifications   -->
      <template v-for="(message, index) in props.chatInfo.messages" :key="message.id">
        <div
          v-if="dateHeaderVisible(message, index)"
          class="bg-neutral-20 rounded-[50px] inline-block mx-auto py-[3px] px-10 text-b-xs font-semibold mt-16 mb-8"
        >
          {{ getTime(message.created_at) }}
        </div>
        
        <se-chat-box-divider-info
          v-if="message.is_hire"
          text="Advisor were hired. Paid time started!"
        />
        <se-session-message-bubble
          v-else-if="!message.is_system"
          :class="index > 0 && isMine(message) && isMine(props.chatInfo.messages[index - 1]) ? 'mt-[4px]' : 'mt-8'"
          :message="message"
          :position="isMine(message) ? 'right' : 'left'"
          :history-mode="props.historyMode"
          @on-img-modal-open="(url) => emits('onImgModalOpen', url)"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import {watch} from 'vue';
import {storeToRefs} from 'pinia';
import {messagesBox, scrollBottom} from "@/src/modules/chat/services/chat.service";
import {usersStore} from '@/src/store/users';
import SeChatBoxInfo from "@/src/modules/chat/components/shared/chat-box-info.vue";
import SeChatBoxDividerInfo from "@/src/modules/chat/components/shared/chat-box-divider-info.vue";
import SeSessionMessageBubble from "@/src/modules/chat/components/shared/session-message-bubble.vue";
import useDateFormatter from "@/src/composables/useDateFormatter";

const emits = defineEmits(['onImgModalOpen']);

const props = withDefaults(defineProps<{
  chatInfo: any,
  historyMode: boolean,
}>(), {
  historyMode: false,
});

const users = usersStore()
const {currentUser, isAdvisor, isUser} = storeToRefs(users);

const getTime = (time: any) => {
  let format = new Date(time).getFullYear() !== new Date().getFullYear() ? "MMM dd, YYYY" : "MMM dd";
  return useDateFormatter().formatDate(time, format);
}

const isMine = (message: any) => message.sender_id === currentUser.value.id;
const dateHeaderVisible = (message: any, index: number) => (index > 0 && !useDateFormatter().datesEqual(props.chatInfo.messages[index - 1].created_at, message.created_at)) || index === 0;

watch(() => props.chatInfo.messages, () => {
  console.log("scroll bottom")
  scrollBottom()
})
</script>

<script lang="ts">
export default {
  name: 'SeSessionMessages',
};
</script>
